// extracted by mini-css-extract-plugin
export default {"lang-icon":"LangSwitch_lang-icon__yOkGm","lang-block":"LangSwitch_lang-block__Ga9z8","lang":"LangSwitch_lang__ggt1y"};